import {
  Tooth11Icon, Tooth12Icon, Tooth13Icon, Tooth14Icon,
  Tooth15Icon, Tooth16Icon, Tooth17Icon, Tooth18Icon,
  Tooth21Icon, Tooth22Icon, Tooth23Icon, Tooth24Icon,
  Tooth25Icon, Tooth26Icon, Tooth27Icon, Tooth28Icon,
  Tooth31Icon, Tooth32Icon, Tooth33Icon, Tooth34Icon,
  Tooth35Icon, Tooth36Icon, Tooth37Icon, Tooth38Icon,
  Tooth41Icon, Tooth42Icon, Tooth43Icon, Tooth44Icon,
  Tooth45Icon, Tooth46Icon, Tooth47Icon, Tooth48Icon,
} from '@shared/icons';

export const upperPermanent = [
  {
    value: 'Tooth #18',
    icon: <Tooth18Icon />,
    label: '18',
  },
  {
    value: 'Tooth #17',
    icon: <Tooth17Icon />,
    label: '17',
  },
  {
    value: 'Tooth #16',
    icon: <Tooth16Icon />,
    label: '16',
  },
  {
    value: 'Tooth #15',
    icon: <Tooth15Icon />,
    label: '15',
  },
  {
    value: 'Tooth #14',
    icon: <Tooth14Icon />,
    label: '14',
  },
  {
    value: 'Tooth #13',
    icon: <Tooth13Icon />,
    label: '13',
  },
  {
    value: 'Tooth #12',
    icon: <Tooth12Icon />,
    label: '12',
  },
  {
    value: 'Tooth #11',
    icon: <Tooth11Icon />,
    label: '11',
  },
  {
    value: 'Tooth #21',
    icon: <Tooth21Icon />,
    label: '21',
  },
  {
    value: 'Tooth #22',
    icon: <Tooth22Icon />,
    label: '22',
  },
  {
    value: 'Tooth #23',
    icon: <Tooth23Icon />,
    label: '23',
  },
  {
    value: 'Tooth #24',
    icon: <Tooth24Icon />,
    label: '24',
  },
  {
    value: 'Tooth #25',
    icon: <Tooth25Icon />,
    label: '25',
  },
  {
    value: 'Tooth #26',
    icon: <Tooth26Icon />,
    label: '26',
  },
  {
    value: 'Tooth #27',
    icon: <Tooth27Icon />,
    label: '27',
  },
  {
    value: 'Tooth #28',
    icon: <Tooth28Icon />,
    label: '28',
  },
];

export const lowerPermanent = [
  {
    value: 'Tooth #48',
    icon: <Tooth48Icon />,
    label: '48',
  },
  {
    value: 'Tooth #47',
    icon: <Tooth47Icon />,
    label: '47',
  },
  {
    value: 'Tooth #46',
    icon: <Tooth46Icon />,
    label: '46',
  },
  {
    value: 'Tooth #45',
    icon: <Tooth45Icon />,
    label: '45',
  },
  {
    value: 'Tooth #44',
    icon: <Tooth44Icon />,
    label: '44',
  },
  {
    value: 'Tooth #43',
    icon: <Tooth43Icon />,
    label: '43',
  },
  {
    value: 'Tooth #42',
    icon: <Tooth42Icon />,
    label: '42',
  },
  {
    value: 'Tooth #41',
    icon: <Tooth41Icon />,
    label: '41',
  },
  {
    value: 'Tooth #31',
    icon: <Tooth31Icon />,
    label: '31',
  },
  {
    value: 'Tooth #32',
    icon: <Tooth32Icon />,
    label: '32',
  },
  {
    value: 'Tooth #33',
    icon: <Tooth33Icon />,
    label: '33',
  },
  {
    value: 'Tooth #34',
    icon: <Tooth34Icon />,
    label: '34',
  },
  {
    value: 'Tooth #35',
    icon: <Tooth35Icon />,
    label: '35',
  },
  {
    value: 'Tooth #36',
    icon: <Tooth36Icon />,
    label: '36',
  },
  {
    value: 'Tooth #37',
    icon: <Tooth37Icon />,
    label: '37',
  },
  {
    value: 'Tooth #38',
    icon: <Tooth38Icon />,
    label: '38',
  },
];
